<script setup lang="ts">
import { formatMoneyWithSymbol } from '@/lib/money'
defineProps<{
    value: number | null | undefined
    currencySymbol: string
}>()
</script>

<template>
    <span v-if="value" class="text-xs text-foreground">{{ formatMoneyWithSymbol(value, currencySymbol) }}</span>
    <span v-else class="text-xs text-muted-foreground">-</span>
</template>
